import {getKeyTitle} from "../js/tool";

export const taskStatus = [
    { key: 0, title: '进行中', statusColor: '#1890ff' },
    { key: 1, title: '已完成', statusColor: '#52c41a' },
    { key: 2, title: '已超时', statusColor: '#f5222d' },
]

export const taskOtherFields = [
    {module: "meeting", route: "ActivityMeetingRoom", title: '会议室信息'},
    {module: "furnish", route: "ActivityHomePreview", title: '查看'},
    {module: "guest", route: "ActivityGuest", title: '查看'},
    {module: "traffic-assign", route: "ActivityVehicleAssign", title: '查看'},
    {module: "traffic-vehicle", route: "ActivityVehicle", title: '查看'},
    {module: "traffic-driver", route: "ActivityDriver", title: '查看'},
    {module: "meal-assign", route: "ActivityMealAssign", title: '查看'},
    {module: "meal-type", route: "ActivityMeal", title: '查看'},
    {module: "stay-assign", route: "ActivityStayAssign", title: '查看'},
    {module: "stay-hotel", route: "ActivityHotel", title: '查看'},
    {module: "gift-assign", route: "ActivityGiftAssign", title: '查看'},
    {module: "gift-type", route: "ActivityGift", title: '查看'},
    {module: "receptionist", route: "ActivityReceptionist", title: '查看'},
]

export const getTaskStatusText = function (status) {
    return getKeyTitle(taskStatus, status);
}

export const getTaskStatusColor = function (status) {
    return getKeyTitle(taskStatus, status, "key", "statusColor");
}

export const getStaticTaskField = function (task) {
    const ids = task.module_ids ? task.module_ids.split(",") : [];
    const list = [];
    ids.forEach(id => {
        const field = taskOtherFields.find(f => f.module == id);
        if(field) {
            list.push({...field});
        }
    });
    return list.length > 0 ? list[0] : null;
}
